import { Fragment, Children } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((_theme) => ({
  textFieldRoot: {
    marginBottom: "12px",
  },
  inputStyles: {
    paddingTop: "10.5px",
    paddingBottom: "10.5px",
  },
  selectRoot: {
    paddingTop: "10.5px",
    paddingBottom: "10.5px",
  },
}));

const MySelectField = (props) => {
  const {
    customLabel,
    children,
    slotProps: slotPropsProp = {},
    SelectProps: selectPropsLegacy,
    ...rest
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const hasOptions = Children.count(children) > 0;

  if (!hasOptions) {
    return (
      <Fragment>
        {customLabel && customLabel.length > 0 ? (
          <Typography variant="subtitle1">{customLabel}</Typography>
        ) : null}
        <TextField
          fullWidth
          disabled
          className={classes.textFieldRoot}
          variant="outlined"
          slotProps={slotPropsProp}
          {...rest}
          value=""
          placeholder={t("Ladataan…")}
        />
      </Fragment>
    );
  }

  const slotProps = {
    ...slotPropsProp,
    select: {
      classes: { root: classes.selectRoot },
      MenuProps: {
        className: classes.menu,
      },
      ...(selectPropsLegacy || {}),
      ...(slotPropsProp.select || {}),
    },
  };

  return (
    <Fragment>
      {customLabel && customLabel.length > 0 ? (
        <Typography variant="subtitle1">{customLabel}</Typography>
      ) : null}

      <TextField
        fullWidth
        select
        className={classes.textFieldRoot}
        slotProps={slotProps}
        variant="outlined"
        {...rest}
      >
        {children}
      </TextField>
    </Fragment>
  );
};

export default MySelectField;
